import React,{useEffect, useState} from "react"
import { Row, Col, Card, CardBody, CardTitle, InputGroup, Label, FormGroup, Button, Modal, Pagination, PaginationItem, PaginationLink } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import Flatpickr from "react-flatpickr"
import { useNavigate } from 'react-router-dom';
import Select from "react-select"
import { connect } from "react-redux";
import * as url from "./../../helpers/url_helper"
import { setBreadcrumbItems } from "../../store/actions";
import moment from "moment"
import { RingLoader } from "react-spinners";
import { BarLoader } from "react-spinners";

const Bordereaux = (props) => {
  document.title = "Opérations | Interface des opérations";
  const navigate = useNavigate();
  const breadcrumbItems = [
    { title: "Lexa", link: "#" },
    { title: "Tables", link: "#" },
    { title: "Responsive Table", link: "#" },
  ]
  const [loadingBord, setLoadingBord] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  const [currPage, setCurrPage] = useState(0);
  const [agences, setAgences] = useState([]);
  const [dest, setDest] = useState("");
  const [agexp, setAgexp] = useState('');
  const [selectedDest, setSelectedDest] = useState(null);
  const [operations, setOperations] = useState([]);
  const [lockMessage, setLockMessage] = useState(null);
  const [bords, setBords] = useState([]);
  const [bord, setBord] = useState('');
  const [totalBords, setTotalBords] = useState(0);
  const [car, setCar] = useState("");
  const [status, setStatus] = useState("");
  const [agTransit, setAgTransit] = useState(null);
  const [agTransitUpdate, setAgTransitUpdate] = useState(null);
  const [heure, setHeure] = useState(moment().format("YYYY-MM-DD HH:mm"));
  const [heureUpdate, setHeureUpdate] = useState(moment().format("YYYY-MM-DD HH:mm"));
  const [selectedAgTransit, setSelectedAgTransit] = useState(null);
  const [selectedAgTransitUpdate, setSelectedAgTransitUpdate] = useState(null);
  const [selectedOrigine, setSelectedOrigine] = useState(null);
  const handleAgTransit= (event)=>{ setSelectedAgTransit(event); setAgTransit(event.value); }
  const handleAgTransitUpDate= (event)=>{ setSelectedAgTransitUpdate(event); setAgTransitUpdate(event.value); }
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const optionGroup = [ { options: agences } ]
  const optionStatus = [ { options: [{label: "En attente", value: 1}, {label: "Expédié", value: 2}, {label: "Arrivé à destination", value: 3}] } ]
  const [modal_opera, setmodal_opera] = useState(false)
  const [modal_lock, setmodal_lock] = useState(false)
  const [modal_send, setmodal_send] = useState(false)
  const [modal_update, setmodal_update] = useState(false)
  let [loading, setLoading] = useState(false);
  let [lockLoading, setLockLoading] = useState(false);
  const [msgError, setMsgError]= useState("");
  const [msgSuccess, setMsgSuccess]= useState("");
  const handleStartDate= (date)=>{ setStartDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleEndDate= (date)=>{ setEndDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleStatus= (event)=>{ setSelectedStatus(event); setStatus(event.value); }
  const [selectedStatus, setSelectedStatus] = useState(null);
  const handleOrigine= (event)=>{ setSelectedOrigine(event); setAgexp(event.value); }
  const handleDestination= (event)=>{ setSelectedDest(event); setDest(event.value); }
  const userJson= JSON.parse(localStorage.getItem("user"));

  const loadAgences= ()=> {
    let userJson= JSON.parse(localStorage.getItem("user"));
    let agencesArray= [{label: "Aucun transit", value: null}];
    fetch(url.BACKEND_URL+"/agence?etp="+userJson.usAgence.agEtp.etpId+"&size=100", {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        agencesArray=[
          ...agencesArray,
          ...responseJson.data.map(item=>({label: item.agNom, value: item.agId}))];
        setAgences(agencesArray);
    } else {  }
    }) .catch((error) => {  });
  };
  function removeBodyCss() { document.body.classList.add("no_padding") }
  function tog_get_opera() { setmodal_opera(!modal_opera); removeBodyCss()}

  const loadBordereaux=(page)=> {
    setLoadingBord(true)
    fetch(url.BACKEND_URL+"/bordereau?start="+startDate+"&end="+endDate+"&page="+page+"&etp="+userJson.usAgence.agEtp.etpId+"&size=30&agexp="+agexp+"&agdest="+dest+"&code="+bord+"&car="+car+"&stat="+status, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { console.log(responseJson.data);
      if (responseJson.status==200) { 
        setBords(responseJson.data)
        setTotalBords(responseJson.totalElement)
        setTotalPage(responseJson.totalPage)
        setCurrPage(responseJson.current_page)
        setLoadingBord(false)
    } else {  
      setBords([])
        setTotalBords(0)
        setTotalPage(0)
        setCurrPage(0)
        setLoadingBord(false)
     }
    }) .catch((error) => { setLoadingBord(false) });
  };
  
  const loadOperation=(bordId)=> {
    setLoading(true);
    fetch(url.BACKEND_URL+"/operation?size=50&bord="+bordId, {
      method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.status==200) { 
        setOperations(responseJson.data)
        setLoading(false);
    } else {  }
    }) .catch((error) => {  });
  };


  useEffect(() => {
    props.setBreadcrumbItems('Bordereaux', breadcrumbItems)
    loadAgences()
    loadBordereaux(0)
  }, [])

  const getOperation=(item)=> {
    return (
        <Row>
          <Col xl="12">
            <div className="table-rep-plugin">
              <div className="table-responsive mb-0" data-pattern="priority-columns">
              <Table id="tech-companies-1" className="table table-striped table-bordered">
              <Tbody>
                      {operations.map((item, key)=>(
                      <Tr>
                        <Th>
                          <strong>{item.opAgdest.agNom}</strong>
                        </Th>
                        <Td>{item.opCode} <br/> {item.detail[0].opdEmbal.embalLibelle}, {item.detail[0].opdNature.natLibelle}</Td>
                        <Td>{moment(item.opCreate).format("DD-MM-YY HH:mm:ss")}</Td>
                        <Td>{item.opExp} ({item.opPhonexp})</Td>
                        <Td>{item.opDest} ({item.opDestphone})</Td>
                        <Td>{item.opFrais} FCFA</Td>
                        <Td style={{ fontSize: 9 }}><strong>{item.opStat.etatLibelle}</strong></Td>
                      </Tr>
                      ))}
                    </Tbody>
              </Table>
              </div>
            </div>
          </Col>
        </Row>);
      };

  return (
    <React.Fragment>
      <Modal size="xl" isOpen={modal_opera} toggle={() => { tog_get_opera() }}>
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">Consultation du bordereau</h5>
        </div>
          {loading ? (<Row style={{ margin: "0 auto", height: 100 }}><RingLoader size={60} color="#36d7b7"/></Row>): getOperation(operations)}
      </Modal>

      <Row>
        <Col xl="3">
          <FormGroup className="mb-4">
            <Label>Début</Label>
            <InputGroup>
              
              <Flatpickr
                className="form-control d-block"
                placeholder="Date début"
                value={startDate}
                onChange={handleStartDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col xl="3">
          <FormGroup className="mb-4">
            <Label>Fin</Label>
            <InputGroup>
              <Flatpickr
                className="form-control d-block"
                placeholder="Date Fin"
                value={endDate}
                onChange={handleEndDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col lg="3">
          <div className="mb-3">
            <Label>Origine</Label>
            <Select
              value={selectedOrigine}
              onChange={handleOrigine}
              options={optionGroup}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
        <Col lg="3">
          <div className="mb-3">
            <Label>Destination</Label>
            <Select
              value={selectedDest}
              onChange={handleDestination}
              options={optionGroup}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
        <Col xl="3">
          <FormGroup className="mb-3">
            <div className="mb-0">
              <label className="form-label" htmlFor="formrow-firstname-input">Numéro Bordereau</label>
              <input type="text" className="form-control" value={bord} onChange={(event)=>setBord(event.target.value)} id="exp" placeholder="Numéro du bordereau"/>
            </div>
          </FormGroup> 
        </Col>
        <Col xl="3">
          <FormGroup className="mb-3">
            <div className="mb-0">
              <label className="form-label" htmlFor="formrow-firstname-input">Numéro Bus</label>
              <input type="text" className="form-control" value={car} onChange={(event)=>setCar(event.target.value)} id="exp" placeholder="Numéro du bus"/>
            </div>
          </FormGroup> 
        </Col>
        <Col lg="3">
          <div className="mb-3">
            <Label>Status</Label>
            <Select
              value={selectedStatus}
              onChange={handleStatus}
              options={optionStatus}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
        <Col lg="3">
          <div className="mt-3">
            <Button type="button" style={{ width: "100%" }} onClick={()=>{loadBordereaux(0)}} color="primary" data-toggle="Button" size="lg" className="mt-2 waves-effect waves-light">Rechargé</Button>
          </div>
        </Col>
      </Row>
     <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="h4">{totalBords} élément(s) </CardTitle>
              <Card>
                {totalPage ==0 ? ( null): totalPage>=25 ? (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: 25}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadBordereaux(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadBordereaux(totalPage-1)}>......{totalPage-1}</PaginationLink></PaginationItem>
                      <PaginationItem><PaginationLink onClick={()=>loadBordereaux(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>): (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: totalPage}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadBordereaux(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadBordereaux(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>)}
              </Card>

              <div className="table-rep-plugin">
                <div
                  className="table-responsive mb-0"
                  data-pattern="priority-columns"
                >
                  <div>
                    {loadingBord ? (<BarLoader width={"100%"} height={6}/>): null}
                  </div>
                  <Table
                    className=""
                    style={{ fontSize: 11 }}
                  >
                    <Thead>
                      <Tr>
                        <Th>Itinéraire</Th>
                        <Th data-priority="1">Code</Th>
                        <Th data-priority="3">Créateur</Th>
                        <Th data-priority="3">Date et heure Création</Th>
                        <Th data-priority="3">Heure envoie/ Car</Th>
                        <Th data-priority="3">Etat</Th>
                        <Th colspan="2" data-priority="6">Détail</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {bords.map((item, key)=>{
                        const getBackgroundColor = (etatLibelle) => {
                          switch(etatLibelle) {
                            case 1:
                              return 'transparent'; 
                            case 5:
                              return 'rgba(88, 219, 131, 0.5)';
                            case 2:
                              return 'rgba(13, 202, 240, 0.5)';
                          }
                        };
                        return (<tr key={key} style={{ backgroundColor: getBackgroundColor(item.bordStat.etatId) }}>
                        <td><strong>{item.bordAgexp.agNom} {'=>'} {item.bordAgdest.agNom}</strong></td>
                        <td>{item.bordCode}</td>
                        <td>{item.bordUser.usNom}</td>
                        <td>{moment(item.bordCreate).format("DD-MM-YYYY HH:mm:ss")}</td>
                        <td>{item.bordCar ? moment(item.bordHeure).format("HH:mm") +"/Car N°_"+item.bordCar: null}</td>
                        <td style={{ fontSize: 9 }}><strong>{item.bordStat.etatLibelle}</strong></td>
                        <td><Button className={item.bordStat.etatId==1 ? "" : item.bordStat.etatId==2 ? "btn btn-info": "btn btn-success"} onClick={()=>{loadOperation(item.bordId); setTimeout(() => { tog_get_opera() }, 200);}}><i className="fa fa-eye"></i></Button></td>
                      </tr>)
                      })}
                      
                    </Tbody>
                  </Table>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

    </React.Fragment>
  )
}
export default connect(null, { setBreadcrumbItems })(Bordereaux);